import React from 'react';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';

class LoginStreak extends React.Component {
  render() {
    return (
      <div className="stats-card">
        <div className="circle-icon">
          <i className="icon-calendar stats-icon" />
        </div>
        {this.props.loginStreakWaiting && (
          <CircularLoading className="loading-resource-gif" />
        )}
        {(this.props.day || this.props.day === 0) &&
          !this.props.loginStreakWaiting && (
            <p className="title">
              {this.props.day}
              <span>day</span>
            </p>
          )}
        {(this.props.day || this.props.day === 0) &&
          !this.props.loginStreakWaiting && (
            <p className="information">LOGIN STREAK</p>
          )}
        {(this.props.longest || this.props.longest === 0) &&
          !this.props.loginStreakWaiting && (
            <p className="stats-footer">Longest - {this.props.longest} </p>
          )}
      </div>
    );
  }
}

export default LoginStreak;
